import { render, staticRenderFns } from "./DataTitle.vue?vue&type=template&id=6c0af7aa&scoped=true&lang=pug"
import script from "./DataTitle.vue?vue&type=script&lang=js"
export * from "./DataTitle.vue?vue&type=script&lang=js"
import style0 from "./DataTitle.vue?vue&type=style&index=0&id=6c0af7aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0af7aa",
  null
  
)

export default component.exports